import { gql } from '@apollo/client';

export const GET_ROLE_PERMISSIONS = gql`
  query searchRolePermissionScopes {
    searchRolePermissionScopes {
      items {
        id
        permissionId
        projectId
        roleId
        permission {
          id
          description
          name
        }
        role {
          id
          name
          description
        }
      }
    }
  }
`;

export const ADD_DELETE_ROLE_PERMISSION = gql`
  mutation AddDeleteRolePermissionScope($addDeleteRolePermissionsInput: AddDeleteRolePermissionsInput!) {
    addDeleteRolePermissionScope(addDeleteRolePermissionsInput: $addDeleteRolePermissionsInput) {
      error
      items {
        id
        permissionId
        projectId
        roleId
        scopeId
      }
    }
  }
`;
